import {
  onboardingProgressSchema,
  onboardingSampleDataSchema,
  type OnboardingProgress,
  type OnboardingSampleData,
  type OnboardingStepKey,
  type OnboardingStepStatus,
} from '@tailoring-crm/shared';
import type { ApiClient } from '../api/client.js';

/** The setup checklist, the guided walkthrough and the sample data — five calls in total. */

const ONBOARDING = '/onboarding';

export async function getOnboarding(client: ApiClient): Promise<OnboardingProgress> {
  return await client.get(ONBOARDING, { schema: onboardingProgressSchema });
}

export async function setOnboardingStep(
  client: ApiClient,
  key: OnboardingStepKey,
  status: OnboardingStepStatus,
): Promise<OnboardingProgress> {
  return await client.put(
    `${ONBOARDING}/steps/${key}`,
    { status },
    { schema: onboardingProgressSchema },
  );
}

export async function dismissGuidedTour(client: ApiClient): Promise<OnboardingProgress> {
  return await client.post(`${ONBOARDING}/tour/dismiss`, {}, { schema: onboardingProgressSchema });
}

export async function loadSampleData(client: ApiClient): Promise<OnboardingSampleData> {
  return await client.post(`${ONBOARDING}/sample-data`, {}, { schema: onboardingSampleDataSchema });
}

export async function removeSampleData(client: ApiClient): Promise<OnboardingSampleData> {
  return await client.del(`${ONBOARDING}/sample-data`, { schema: onboardingSampleDataSchema });
}
